/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/ChangeFileExtension.ts
 * @create:      2025-07-01 17:59:49.642
 * @modify:      2025-07-11 21:19:12.964
 * @version:     6.0.0
 * @times:       5
 * @lines:       55
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { TrimEnd } from "../string/TrimEnd";
import { TrimStart } from "../string/TrimStart";
import { GetFileExtension } from "./GetFileExtension";

/**
 * Changes the extension of a given file name to the specified extension.
 *
 * @param fileName - The original file name whose extension is to be changed.
 * @param extension - The new extension to be applied (with or without a leading dot).
 * @returns The file name with the new extension.
 * 
 * @since 1.0.5
 * @version 2021-12-07
 */
export function ChangeFileExtension(fileName: string, extension: string): string {
    let ext = GetFileExtension(fileName);
    const root = TrimEnd(fileName, [ext, "."], false);

    ext = TrimStart(extension, ".");

    return `${root}.${ext}`;
}
